import { Component, signal, inject, OnInit, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('monthly-order');

  // environment.production is shared by every domain this build is deployed to (e.g. event/*
  // pages on event-order.sakuramobile.jp); the oaiq init tag must only fire on this one.
  private readonly TARGET_HOSTNAME = 'longterm-order.sakuramobile.jp';

  private readonly document = inject(DOCUMENT);
  private readonly renderer = inject(Renderer2);

  ngOnInit(): void {
    if (!environment.production) return;
    if (this.document.defaultView?.location.hostname !== this.TARGET_HOSTNAME) return;

    const initScript = this.renderer.createElement('script');
    initScript.text = `
      !function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");
      oaiq("init",{pixelId:"Amwmx1j5YYx7ZrVpA9X1kt",debug:true});
    `;

    this.renderer.appendChild(this.document.head, initScript);
  }
}
